module.exports = __webpack_public_path__ + "img/3_135.35dbce34.png";